import React from 'react'

function NoData_Kratos() {
  return (
    <>
      <div className="v-title chartbox">
        <div className="chartHGT">
          <div className="alert alert-danger no_data">records not found</div>
          <div style={{ height: "80px" }} ></div>
        </div>
      </div>
    </>
  )
}

export default NoData_Kratos